import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Attributes inherit from the API EnumSettingResource.
const PcsProviderSettingSchema = withDefaults({
  type: 'pcs-provider-setting',
  fields: [
    { kind: 'attribute', name: 'enum' },
    { kind: 'attribute', name: 'subject' },
    { kind: 'attribute', name: 'predicate' },
    { kind: 'attribute', name: 'value' },
    {
      kind: 'belongsTo',
      name: 'pcsProvider',
      type: 'pcs-provider',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsProviderSettingSchema;
